import React from 'react';
import PropTypes from 'prop-types';
import RefreshCwIcon from '../../../shared/Icons/RefreshCwIcon';

const SeriesNameCell = ({ name, venueName, imageUrl, showUrl }) => (
  <div className="team-member-info series-name-cell">
    <div className="team-avatar series-name-avatar">
      {imageUrl ? (
        <img src={imageUrl} alt="" className="series-name-avatar-img" />
      ) : (
        <RefreshCwIcon width="16" height="16" />
      )}
    </div>
    <div className="team-member-details">
      <div className="series-name-title">
        {showUrl ? (
          <a href={showUrl} className="stretched-link series-name-link">{name}</a>
        ) : (
          name
        )}
      </div>
      {venueName && (
        <div className="series-name-venue">{venueName}</div>
      )}
    </div>
  </div>
);

SeriesNameCell.propTypes = {
  name: PropTypes.string.isRequired,
  venueName: PropTypes.string,
  imageUrl: PropTypes.string,
  showUrl: PropTypes.string,
};

export default SeriesNameCell;
